import React from "react";
import  { useState, useEffect,useRef } from 'react';
import { useParams } from 'react-router-dom';
import {useNavigate, useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ViewAthlete.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { configData } from "../config";
import Select from 'react-dropdown-select';
import ReactSelect from 'react-select';
import Editor from "react-simple-wysiwyg";
import Loading from './Loading';
import './classes/Modal.css';
import PhotoEditor from './PhotoEditor.js';

const Viewathlete = () => {
  const [representedByDirectors, setRepresentedByDirectors] = useState(false);
   const[showEventViewModal, setShowEventViewModal] = useState(false);
   const [showEditModal, setShowEditModal] = useState(false);
   const [showSportEditModal, setShowSportEditModal] = useState(false);
  const [showAcceptAthlete, setshowAcceptAthlete] = useState(false);
const [showRedButton, setshowRedButton] = useState(true);
const [showcheckBox, setshowcheckBox] = useState(true);
const [showMyAthlete, setshowMyAthlete] = useState(true);
  const [loading, setLoading] = useState(false);
  const loggedin_uid = localStorage.getItem('drupal_uid');
   const navigate = useNavigate();
  const[athletedetails, setAthleteDetails] = useState({});
  const[sportsDetails,setSportsDetails] = useState ([]);
  const[agentDetails,setAgentDetails] = useState ([]);
  const [isLoading, setIsLoading] = useState(true);
   const [eventlist, setEventList] = useState({});
   const [eventdetailedview, setEventDetailedView] = useState({});
   const [statelist, setStateList] = useState({});
    const [countriesList, setCountriesList] = useState([]);
    const [positionsList, setPositionList] = useState([]);
    const [sportpositionsList, setsportPositionList] = useState([]);
    const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);     
    const [publicurl, setpublicurl] = useState('');
    const [addedFields, setAddedFields] = useState([]);
    const [removedFields, setRemovedFields] = useState([]);

    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const modalContentRef = useRef(null);
    const[successAthleteMessage,setSuccessAthleteMessage] = useState('');
    const location = useLocation();
    const successMessage = location.state?.message;
    // window.history.replaceState({}, '');
    const [adminSuccess ,setAdminSuccess] = useState('');

        useEffect(() => {
          if (successMessage) {
            setSuccessAthleteMessage(successMessage);
            window.history.replaceState({}, '');
          }
        }, [successMessage, location.state]);

    const initialFormData = {
      picture: null,
      first_name:'',
      last_name:'',
  street_address: '',
  field_street_2: '',
  city:'',
  state:'',
  postal_code:'',
  country:'',
  email:'',
  primary_phone:'',
  field_secondary_phone:'',
  field_night_phone:'',
  field_linkedin_url:'',
  field_fax: '',
  field_pager: '',
  sportsId:'',
  positions:[],
  field_athlete_type:'',
  field_agents_represented_by:[],
  birth_month: "",
  birth_date: "",
  birth_year: "",
  field_nationality:"",
  height_ft: '',
  height_in: '',
  height_cm: '',
  field_athlete_height:'',
  field_height_unit: 'Imperial',
  field_athlete_weight: '',
  field_weight_unit: 'lb',
  field_most_recent_college:'',
  field_video_highlights:'',
  field_most_recent_seasons_stats:'',
  field_career_information:'',
  field_instagram_url:'',
  field_instagram_handle:'',
  field_instagram_followers:'',
  field_facebook_url:'',
  field_facebook_handle:'',
  field_facebook_followers:'',
  field_twitter_url:'',
  field_twitter_followers:'',
  field_user_youtube_url:'',
  field_youtube_subscribers:'',
  linkedin_url:'',
  field_linkedin_handle:'',
  field_linkedin_followers:'',
  field_tiktok_url:'',
  field_tiktok_followers:'',
  field_how_to_contact_client:'',
  field_biography:'',
  field_show_on_frontend_athlete:0,
  field_represented_by_directors:1,
  drupal_uid:drupal_uid,
  removed_agentids:[]
  
};
const[success,setSuccess] = useState({});
const [formData, setFormData] = useState(initialFormData);
const agents_represent = athletedetails.field_agents_represented_by || [];
const [originalData, setOriginalData] = useState({});
const initialsportFormData = {
   sportsId:'',
  positions:'',  
athleteSportId: ''
};
const [sportformData, setsportFormData] = useState(initialsportFormData);
  const [errors, setErrors] = useState({});
   const [athleteType, setAthleteType] = useState({});
   const [sportList, setSportList] = useState('');
   const [assignedAthletes, setAssignedAthleteList] = useState([]);
   const [agents, setAgentList] = useState([]);
const [showonfrontenderrors, setShowOnFrontendErrors] = useState({});
  
const agentOptions = [
  { id: 917231, name: "TestRj" },
  { id: 917280, name: "Abdoulaye Sarr" },
  { id: 917300, name: "Aaron Tuioti-Mariner" }
];
const agentOptionsFormatted = agents.map(a => ({
  value: a.id,
  label: a.name
}));
const currentYear = new Date().getFullYear();
 const months = [
    { value: "01", label: "Jan" },
    { value: "02", label: "Feb" },
    { value: "03", label: "Mar" },
    { value: "04", label: "Apr" },
    { value: "05", label: "May" },
    { value: "06", label: "Jun" },
    { value: "07", label: "Jul" },
    { value: "08", label: "Aug" },
    { value: "09", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  
  const days = Array.from({ length: 31 }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return { value: day, label: day };
  });

  const years = Array.from(
    { length: currentYear - 1950 + 1 },
    (_, i) => {
      const year = String(currentYear - i);
      return { value: year, label: year };
    }
  );

  const onEditorChange = (fieldName, e) => {
  let newHtml = e?.target?.value ?? "";

  // Wrap raw plain text that isn't already in HTML
  if (newHtml && !newHtml.startsWith("<")) {
    newHtml = `<p>${newHtml}</p>`;
  }

  // Remove meaningless HTML
  if (newHtml === "<br>" || newHtml === "<p><br></p>") {
    newHtml = "";
  }

  setFormData(prev => ({
    ...prev,
    [fieldName]: newHtml
  }));

  // Optional: clear error for that field
  //setErrors?.(prev => ({ ...prev, [fieldName]: "" }));
};


   var {drupal_uid} = useParams();
 const app_url = configData.APP_URL;
   useEffect(() => {
    getagentlist();
     getfieldslist();
     getsportslist();
      retrieveAthleteDetails();
      retrieveStateList();
      retrieveCountriesList();
      geteventlist();
      getpendingapprovalfields();
      getuserloggedinroles();
    },[]);
    async function getagentlist() {
   
         try {
            const response = await fetch(
               app_url+'user/getagentlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAgentList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
       async function getfieldslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwfieldlist/getfieldlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
               setAthleteType(responsedata.data.athletetype);
            } 
        } catch (err) {
            
         }
        
  }
      async function getsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwathlete/getathletesports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }
  async function getpendingapprovalfields() {
    
         try {
            const response = await fetch(
                app_url+'smwwathlete/getpendingapprovalfields?drupal_uid='+drupal_uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            setAddedFields(responsedata.data.added_fields);
            setRemovedFields(responsedata.data.removed_fields);
            } 
        } catch (err) {
            
         }
        
  }
   async function getpositionlist(sportsId) {
    
         try {
            const response = await fetch(
                app_url+'smwwathlete/getsportsposition?id='+sportsId,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setPositionList(responsedata.data);
                setsportPositionList(responsedata.data);
                 return responsedata.data;
               
            } 
        } catch (err) {
            
         }
        
  }
  const parseNumber = (val) =>
  val ? Number(String(val).replace(/[^0-9.]/g, "")) : "";
  
   async function retrieveAthleteDetails() {
    if(drupal_uid && !Number.isNaN(drupal_uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwwathlete/getathletedetails?drupal_uid='+drupal_uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               console.log('sports Details:', responsedata.data.sports);
                setAthleteDetails(responsedata.data.result);
                setFormData({
                    ...responsedata.data.result,
                    height_ft: parseNumber(responsedata.data.result.height_ft),
                    height_in: parseNumber(responsedata.data.result.height_in),
                });
                //setFormData(responsedata.data.result);
                setOriginalData(responsedata.data.result);
                setSportsDetails(responsedata.data.sports);
                setAgentDetails(responsedata.data.agent_list);
                if(responsedata.data.red_button == "No") {
               setshowRedButton(false);
               setshowAcceptAthlete(true);
                }
                if(responsedata.data.frontend == "No") {
                  setshowcheckBox(false);
                }
                if(responsedata.data.my_athlete == "No") {
                  setshowMyAthlete(false);
                }
                if(responsedata.data.public_url) {
                  setpublicurl(responsedata.data.public_url);
                }
            } 
        } catch (err) {
            
         }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
        }
  }
    useEffect(() => {
        if (!formData || !countriesList.length) return;
        const selected = countriesList.find(
            item => item.value === formData.country
        );
        if (selected) {
            setSelectedCountry([selected]);
        }
    }, [formData, countriesList]);
  console.log('sports Details:', athletedetails);
      async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
      async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }
  async function geteventlist() {
    if(drupal_uid && !Number.isNaN(drupal_uid)) {
        
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'smwweventlog/getusereventlist?uid='+drupal_uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setEventList(responsedata.data.result);
            } 
        } catch (err) {
            
         }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
        }
  }

  async function getuserloggedinroles() {
    try {
      const response = await fetch(
        app_url+'viewprofile/getuserloggedinrolesid',
        {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
            },
        }
      )
      const responsedata = await response.json();
      if(responsedata.data) {
        setUserLoggedInRoles(responsedata.data.roles);
      } 
    } catch (err) {
        
    }
  }

   const handleModalOpen = (modalname) => {
       
        if(modalname == 'view_event_log') {
            setShowEventViewModal(true);
        }
       
        
    };
    const handleViewModalOpen = async (modalname,eventid) => {
       
        if(modalname == 'view_event_log') {
            setShowEventViewModal(true);
          
            if(drupal_uid && !Number.isNaN(drupal_uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwweventlog/getusereventdetailedview?uid='+drupal_uid+'&eventid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setEventDetailedView(responsedata.data.result);
                    
                } 
                } catch (err) {
                }
            }
        

        }
       
    };
    const handlesendchangesapproval = async (drupal_uid) => {
       
                try {
                const response =  await fetch(
                app_url+'profileapproval/sendchangestoapproval?drupal_uid='+drupal_uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") { 
                    
                    // alert("Your athlete has been submitted to be publicly displayed viewable at SMWWAgency.com.");
                    navigate(`/athlete/requestapproval/${drupal_uid}`); 
                    
                } 
                } catch (err) {
                }
           
       
    };

    const [isChecked, setIsChecked] = useState(false);
    const [isRepresentedChecked, setIsRepresentedChecked] = useState(true);

    useEffect(() => {
      setIsChecked(formData.field_show_on_frontend_athlete === 1);
    }, [formData.field_show_on_frontend_athlete]);
    
    const handleShowOnFrontendChange = async (e,drupal_uid) => {
       const newValue = e.target.checked ? 1 : 0;
        setIsChecked(e.target.checked);
                try {
                const response =  await fetch(
                app_url+'smwwathlete/putshowonfrontend?drupal_uid='+drupal_uid+'&newValue='+newValue,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") { 
                   
                    alert("Success");
                    // geteventlist();
                    // setIsChecked(e.target.checked);
                    
                }
                if(responsedata.data.msg == "Error") {
                    setIsChecked(false); 
                    setShowOnFrontendErrors(responsedata.data.result);
              
                } 
                } catch (err) {
                }
           
       
    };

    useEffect(() => {
      setIsRepresentedChecked(formData.field_represented_by_directors === 1);
    }, [formData.field_represented_by_directors]);

    const handleRepresentedByChange = async (e,drupal_uid) => {
      const newValue = e.target.checked ? 1 : 0;
      setIsRepresentedChecked(e.target.checked);
      try {
        const response =  await fetch(
          app_url+'smwwathlete/putathleterepresentedbydirectors?drupal_uid='+drupal_uid+'&newValue='+newValue,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        const responsedata =  await response.json();
      
        if(responsedata.data.msg == "Success") { 
          alert("Success");
          // geteventlist();
          // setIsRepresentedChecked(e.target.checked);
            
        } 
      } catch (err) {

      }
    };
    
    const handleModalClose = (modalname) => {
       
        if(modalname == 'view_event_log') {
        setShowEventViewModal(false);
        setEventDetailedView({});
        }
        
    };


    const handleEditModalOpen = () => {
  setShowEditModal(true);
};

const handleEditModalClose = () => {
  setShowEditModal(false);
};

const handleSportEditModalOpen = async (item) => {
  // 1. Find sportId using sportName
  const sport = sportList.find(s => s.value === item.sportName);
  const sportId = sport ? String(sport.key) : "";

  // 2. Load positions for this sport
  const positionsList = await getpositionlist(sportId);

  // 3. Find matching position by name
  const position = positionsList.find(
    p => p.name === item.positionName
  );

  // 4. Set form data (PRESELECTED)
  setsportFormData({
    sportsId: sportId,
    positions: position ? position.id : "",
    athleteSportId: item.id //  IMPORTANT for update
  });

  // 5. Open modal
  setShowSportEditModal(true);
};


const handleSportEditModalClose = () => {
  setShowSportEditModal(false);
};
const handleSportDelete = async (item) => {
  if (!window.confirm("Are you sure remove this sport ?")) return;

  try {
    const res = await fetch(
      app_url + 'smwwathlete/removesport',
      {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          athleteSportId: item.id, // send row id
          drupal_uid: drupal_uid
        })
      }
    );

    const data = await res.json();
    if(data.data.msg == 'Success') {
    // alert(data.data.result);
    setSuccess('');
    setAdminSuccess('The changes have been saved.');
    window.scrollTo(0, 0);
    geteventlist();
    }
    console.log("Deleted:", data);

    //  Refresh list
    retrieveAthleteDetails();
  } catch (err) {
    console.error("Delete error:", err);
  }
};

const handleTableAgentDelete = async (agentId) => {
  if (!window.confirm("Are you sure you want to remove this agent?")) return;

  try {
    const response = await fetch(
      app_url + "smwwathlete/removeagent",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          agent_id: agentId,     
          drupal_uid: drupal_uid 
        }),
      }
    );

    const data = await response.json();
    if(data.data.msg == 'Success') {
      retrieveAthleteDetails();
      window.scrollTo(0, 0);
      if (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) {
        setAdminSuccess('The changes have been saved.');
        setSuccess('');
        window.scrollTo(0,0);
      } else {
        setSuccess(data.data.result);
        setAdminSuccess('');
        window.scrollTo(0,0);
      }
      // setSuccess(data.data.result);
      // alert(data.data.result);
    }

    //  Update UI without reload
    setAgentDetails(prev =>
      prev.filter(agent => agent.id !== agentId)
    );

  } catch (err) {
    console.error("Delete failed:", err);
  }
};

const handleAgentDelete = (id) => {
  setAgentDetails(prev => prev.filter(agent => agent.id !== id));

  setFormData(prev => {
    const filteredAgents = (prev.field_agents_represented_by || []).filter(a => {
      if (!a) return false; // remove null or empty string
      if (typeof a === "number" || typeof a === "string") return String(a) !== String(id);
      if (a?.value !== undefined) return String(a.value) !== String(id);
      if (a?.id !== undefined) return String(a.id) !== String(id);
      return true;
    });

    return {
      ...prev,
      field_agents_represented_by: filteredAgents,
      removed_agentids: [...new Set([...(prev.removed_agentids || []), id])]
    };
  });
};

const handlePictureDelete = async (drupal_uid) => {
 
  try {
    const response = await fetch(
      app_url + "smwwathlete/deletephoto",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
               
          drupal_uid: drupal_uid 
        }),
      }
    );

    const data = await response.json();
    if(data.data.msg == 'Success') {
    setSuccess(data.data.result);
    setAdminSuccess('');
  }
    retrieveAthleteDetails();
    geteventlist();
    getpendingapprovalfields();

  } catch (err) {
    console.error("Delete failed:", err);
  }
};


const isValidBasicPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  return cleaned.length >= 7 && cleaned.length <= 15;
};

const validate = (formData) => {
  const newErrors = {};

  // Email
  if (!formData.email?.trim()) {
    newErrors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = 'Invalid email format';
  }

  // Phone
  if (formData.primary_phone?.trim()) {
    if (!isValidBasicPhone(formData.primary_phone)) {
      newErrors.primary_phone = 'Invalid Phone Number';
    }
  }

  // Secondary phone
  if (formData.field_secondary_phone?.trim()) {
    if (!isValidBasicPhone(formData.field_secondary_phone)) {
      newErrors.field_secondary_phone = 'Invalid Secondary Phone Number';
    }
  }

  //linkedin url
if (formData.field_linkedin_url?.trim()) {
  const linkedin = formData.field_linkedin_url.trim();

  if (!/linkedin\.com\//.test(linkedin)) {
    newErrors.field_linkedin_url = 'Invalid LinkedIn URL';
  }
}
  //instagram url
if (formData.field_instagram_url?.trim()) {
  const instaurl = formData.field_instagram_url.trim();

  if (!/instagram\.com\//.test(instaurl)) {
    newErrors.field_instagram_url = 'Invalid Instagram URL';
  }
}  //facebook url
if (formData.field_facebook_url?.trim()) {
  const facebook = formData.field_facebook_url.trim();

  if (!/facebook\.com\//.test(facebook)) {
    newErrors.field_facebook_url = 'Invalid Facebook URL';
  }
}  
//youtube url
if (formData.field_user_youtube_url?.trim()) {
  const youtube = formData.field_user_youtube_url.trim();

  if (!/youtube\.com\//.test(youtube) && !/youtu\.be\//.test(youtube)) {
    newErrors.field_user_youtube_url = 'Invalid Youtube URL';
  }
}  
//twitter url
if (formData.field_twitter_url?.trim()) {
  const twitter = formData.field_twitter_url.trim();

  if (!/twitter\.com\//.test(twitter) && !/x\.com\//.test(twitter)){
    newErrors.field_twitter_url = 'Invalid Twitter URL';
  }
}  //tiktok url
if (formData.field_tiktok_url?.trim()) {
  const tiktok = formData.field_tiktok_url.trim();

  if (!/tiktok\.com\//.test(tiktok)) {
    newErrors.field_tiktok_url = 'Invalid Tiktok URL';
  }
}
  // DOB
  // if (!formData.birth_month || !formData.birth_date || !formData.birth_year) {
  //   newErrors.dob = 'Please select your date of birth';
  // }
 // Nationality
  // if (!formData.field_nationality?.trim()) {
  //   newErrors.field_nationality = 'Nationality is required';
  // }
  // Height
  // if (formData.field_height_unit === 'Imperial') {
  //   if (!formData.height_ft || !formData.height_in) {
  //     newErrors.height = 'Please enter height in feet and inches';
  //   }
  // } else if (formData.field_height_unit === 'Metric') {
  //   if (!formData.height_cm) {
  //     newErrors.height = 'Please enter height in cm';
  //   }
  // }

  // Weight
  // if (!formData.field_athlete_weight) {
  //   newErrors.field_athlete_weight = 'Please enter your weight';
  // }
   // Most Recent College
  // if (!formData.field_most_recent_college?.trim()) {
  //   newErrors.field_most_recent_college = 'Most Recent College field is required';
  // }

  // Most Recent Season Stats
  // if (!formData.field_most_recent_seasons_stats?.trim()) {
  //   newErrors.field_most_recent_seasons_stats = 'Most Recent Season Stats field is required';
  // }

  // Career Highlights
  // if (!formData.field_career_information?.trim()) {
  //   newErrors.field_career_information = 'Career Highlights field is required';
  // }

 

 

  return newErrors;
};

const handleEditInputChange = (e) => {
  const { name, value, options, multiple } = e.target;

  setFormData(prev => {
    let updatedValue;

    if (options && multiple) {
      // Multi-select
      updatedValue = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);
    } else {
      // Single value
      updatedValue = value;
    }

    return {
      ...prev,
      [name]: updatedValue
    };
  });

  // keep this OUTSIDE setFormData
  if (name === "sportsId") {
    getpositionlist(value);
  }
};



const handleSportEditInputChange = (e) => {
  const { name, value } = e.target;

  // single select only
  setsportFormData(prev => ({ 
    ...prev, 
    [name]: value 
  }));

  if (name === "sportsId") {
    getpositionlist(value);
  }
};




		const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      country:''
    }));

  };
// const handleEditSubmit = async (e) => {
//   e.preventDefault();
//   console.log("Submit clicked");

//    const oldAgents = athletedetails?.field_agents_represented_by || [];
//   const newAgents = formData?.field_agents_represented_by || [];

//   // Normalize new agents (handle ReactSelect objects or raw values)
//   const normalizedNewAgents = newAgents.map(a =>
//     a && typeof a === "object" && a.value !== undefined ? a.value : a
//   );

//   // Merge without duplicates
//   const mergedAgents = [
//     ...oldAgents,
//     ...normalizedNewAgents.filter(id => !oldAgents.includes(id))
//   ];

//   // Update formData (important!)
//   const updatedFormData = {
//     ...formData,
//     field_agents_represented_by: mergedAgents
//   };

//   console.log("Merged agents:", mergedAgents);

//   const fd = new FormData();

//   Object.entries(formData).forEach(([key, value]) => {
//     if (Array.isArray(value)) {
//       // If array of objects (like ReactSelect), extract only values
//       if (value.length && value[0].value !== undefined) {
//         value.forEach((v) => fd.append(`${key}[]`, v.value));
//       } else {
//         value.forEach((v) => fd.append(`${key}[]`, v));
//       }
//     } else {
//       fd.append(key, value ?? "");
//     }
//   });
 

//   // Log entire FormData entries
//   for (let [key, value] of fd.entries()) {
//     console.log("FD entry:", key, value);
//   }
//   fd.append('drupal_uid',drupal_uid);
//   // Send fd to API
//   try {
//     const res = await fetch(
//       app_url + 'smwwathlete/viewathletesubmit',
//       { method: "POST", body: fd }
//     );
//     const data = await res.json();
//     if(data.data.msg === "Success") {
//       setSuccess(data.data.result);
//       handleEditModalClose();
//     }
    

    
//   } catch (err) {
//     console.error("Update error:", err);
//   }
 
// };
const handleEditSubmit = async (e) => {
  e.preventDefault();
  console.log("Submit clicked");

  const validationErrors = validate(formData);
  setErrors(validationErrors);
  setAdminSuccess('');
  setSuccess('');
  setShowOnFrontendErrors({});
  if (Object.keys(validationErrors).length > 0) {
    // window.scrollTo(0, 0);
    modalContentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
 
  setErrors({});

  /**
   * STEP 1: Merge existing + new agents SAFELY
   */
  // const oldAgents = athletedetails?.field_agents_represented_by || [];
  // const newAgents = formData?.field_agents_represented_by || [];

  // // Normalize new agents (handle ReactSelect objects or raw values)
  // const normalizedNewAgents = newAgents.map(a =>
  //   a && typeof a === "object" && a.value !== undefined ? a.value : a
  // );

  // // Merge without duplicates
  // // const mergedAgents = [
  // //   ...oldAgents,
  // //   ...normalizedNewAgents.filter(id => !oldAgents.includes(id))
  // // ];

  // // // Update formData (important!)
  // // const updatedFormData = {
  // //   ...formData,
  // //   field_agents_represented_by: mergedAgents
  // // };

  // // console.log("Merged agents:", mergedAgents);
  // // Compare old vs new
  // const isSame =
  //   oldAgents.length === normalizedNewAgents.length &&
  //   oldAgents.every((id, idx) => id === normalizedNewAgents[idx]);

  // // Only update if changed
  // const updatedFormData = {
  //   ...formData
  // };

  // if (!isSame) {
  //   updatedFormData.field_agents_represented_by = normalizedNewAgents;
  // } else {
  //   delete updatedFormData.field_agents_represented_by;
  // }
const removedSet = new Set(
  (formData.removed_agentids || []).map(String)
);

const remainingAgents = (formData.field_agents_represented_by || [])
  .map(a =>
    a?.value ?? a?.id ?? a
  )
  .filter(id => !removedSet.has(String(id)));
const updatedFormData = { ...formData };
  if ((formData.removed_agentids || []).length > 0) {
    //  deletion happened → ALWAYS send remaining IDs
    // updatedFormData.field_agents_represented_by = remainingAgents;
    updatedFormData.field_agents_represented_by = remainingAgents.length > 0 ? remainingAgents : []; 
  } else {
    // optional comparison with backend data
    const oldAgents = athletedetails?.field_agents_represented_by || [];

    const isSame =
      oldAgents.length === remainingAgents.length &&
      oldAgents.every((id, idx) => id === remainingAgents[idx]);

    if (!isSame) {
      updatedFormData.field_agents_represented_by = remainingAgents;
    } else {
      delete updatedFormData.field_agents_represented_by;
    }
  }
  /**
   * STEP 2: Build FormData
   */
  const fd = new FormData();

  Object.entries(updatedFormData).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        fd.append(`${key}[]`, v);
      });
    } else {
      fd.append(key, value ?? "");
    }
  });

  // Required backend field
  fd.append("drupal_uid", drupal_uid);

  /**
   * STEP 3: Debug what is being sent
   */
  for (let [key, value] of fd.entries()) {
    console.log("FD entry:", key, value);
  }

  /**
   * STEP 4: Submit
   */
  try {
    const res = await fetch(
      app_url + "smwwathlete/viewathletesubmit",
      {
        method: "POST",
        body: fd
      }
    );

    const data = await res.json();

    if (data?.data?.msg === "Success") {
      setSuccess(data.data.result);
      setAdminSuccess('');
      handleEditModalClose();
    if (!(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) {
      setAddedFields(data.data.added_fields);
      setRemovedFields(data.data.removed_fields);
      }
    }
    retrieveAthleteDetails();
    getpendingapprovalfields();
    geteventlist();
  } catch (err) {
    console.error("Update error:", err);
  }

};

const handleSportEditSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append('sportsId', sportformData.sportsId);
  fd.append('positions', sportformData.positions);
  fd.append('athleteSportId', sportformData.athleteSportId); // row id
  fd.append('drupal_uid', drupal_uid);

  try {
    const res = await fetch(
      app_url + 'smwwathlete/editsportsubmit',
      { method: "POST", body: fd }
    );
    const data = await res.json();
    if(data.data.msg === "Success") {
      // alert(data.data.result);
      setAdminSuccess('The changes have been saved.');
      setSuccess('');
      window.scrollTo(0,0);
    }
    console.log("Updated:", data);

    //  Refresh list
    retrieveAthleteDetails();
    geteventlist();
    setShowSportEditModal(false);
  } catch (err) {
    console.error("Update error:", err);
  }
};



  const handleEditCancel = () => {
    setFormData(originalData);    
    navigate(`/view_athlete/${drupal_uid}`);    
    setShowEditModal(false);   
  };
const getFieldClass = (fieldName) => {
  if (removedFields.includes(fieldName)) return "field-removed";
  if (addedFields.includes(fieldName)) return "field-added";
  return "";
};
// const getAgentClass = (agentId) => {
//   if (removedAgents.includes(agentId)) return "agent-removed";
//   if (addedAgents.includes(agentId)) return "agent-added";
//   return "";
// };
//   const [hasChanges, setHasChanges] = useState(false);
//   useEffect(() => {
//   if (athletedetails && (addedFields.length || removedFields.length)) {
//     setHasChanges(hasAthleteChanges(athletedetails, formData));
//   }
// }, [formData, athletedetails, addedFields, removedFields]);

      const [showConfirmDialog, setShowConfirmDialog] = useState(false);
      const [athleteid, setAthleteId] = useState('');
      const[error,setError] = useState('');

      const handleApprovalClick = (drupal_athlete_id) => {
        setShowConfirmDialog(true);
        setAthleteId(drupal_athlete_id);
      };

      const handleConfirm = async () => {
      setShowConfirmDialog(false);
      try {
        const response = await fetch(
                app_url+'smwwathlete/acceptathlete',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                athleteid: athleteid,
                loggedin_id: localStorage.getItem('drupal_uid')
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              // alert(responsedata.data.result);
              navigate("/pending_athletes", { state: { message: responsedata.data.result } });
              // setSuccess(responsedata.data.result);
              setError('');
              window.scrollTo(0, 0);
            }
             if(responsedata.data.msg == "Error") {
              // alert(responsedata.data.result);
              setError(responsedata.data.result);
              setSuccess('');

            }
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
     const handleCancel = () => {
      setShowConfirmDialog(false);
    };
const DEFAULT_IMAGE = "/basic/web/images/agency_logo.png";
const currentImage =
  typeof formData.picture === "string" && formData.picture
      ? formData.picture
      : typeof athletedetails.picture_url === "string" && athletedetails.picture_url
      ? athletedetails.picture_url
      : DEFAULT_IMAGE;

const hasCustomImage = currentImage !== DEFAULT_IMAGE;

const currentPreviewImage =
    (typeof formData.picture === "string" && formData.picture.trim())
        ? formData.picture
        : (typeof athletedetails.picture_url === "string" && athletedetails.picture_url.trim())
        ? athletedetails.picture_url
        : null;

    return(
       <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="view-athlete-main">
          <Helmet><title>View Athlete</title></Helmet>
            <div className="left"></div>
            <div className="center left-center view-athlete-center"> 
              {success.length > 0 && (
                <>
                {success.map((item, index) => {
                  return <>
                  <br/><div className="set-message-done">
                  <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> 
                  {/* {item} */}
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                  </div></>
                  
                })}  
                </>
              )}
              {successAthleteMessage && (
                <div className="set-message-done">
                  <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successAthleteMessage}
                </div>
              )}
              {adminSuccess && (
                <div className="set-message-done">
                  <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {adminSuccess}
                </div>
              )}

        {showonfrontenderrors.length > 0 && (
          <div className="set-message-error" style={{ padding:"10px 10px 10px 50px",background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {showonfrontenderrors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
        {error && (
          <div className="set-message-error">
          {error}
          </div>
        )}  
                <div className="view-athlete-container">
                                                  
                    <h2>{athletedetails.name}</h2>
                    {(userLoggedInRoles.includes(configData.ROLE_AGENT) && !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) &&
                      <>
                        {showAcceptAthlete &&
                          <>
                            <div style={{marginBottom: "5px"}}>
                              <a style={{cursor: "pointer" }} onClick={() => handleApprovalClick(drupal_uid)}>
                                Accept This Athlete 
                                <img src="/basic/web/images/approve.gif" alt="Approve" border="0" align="top" />
                              </a>
                            </div>
                            {showConfirmDialog && (
                              <div className="dialog-overlay">
                                <div className="dialog-content">
                                  <h2>Confirmation</h2>
                                  <p>By agreeing to represent this athlete, you agree to incur any expenses at your own risk.<br/>
                                    You also agree to split your commission with SMWW as defined in our contractual agreement.<br/>
                                    Click OK to continue and confirm your decision to represent this athlete.
                                  </p>
                                  <div className="dialog-actions">
                                    <button onClick={handleConfirm}>Confirm</button>
                                    <button onClick={handleCancel}>Cancel</button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        }
                        {(showRedButton && showMyAthlete) && 
                        <>
                        <a className="reddbtnn" style={{textTransform:"none",margin:0, cursor: "pointer"}} onClick={() => handlesendchangesapproval(drupal_uid)}>Click here to submit athlete changes to be publicly viewable on SMWWAgency.com</a>
                        <div style={{margin: "1% 0",fontSize:"13px"}}>*Make sure your changes are finalized before submitting your athlete for review.</div></>
                        }
                      </>
                    }
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                      <>
                        {showcheckBox && 
                          <div style={{fontSize: "12px"}}>
                          <input
                          type="checkbox"
                          name="field_show_on_frontend_athlete"
                          key={formData.field_show_on_frontend}
                          // checked={formData.field_show_on_frontend_athlete === 1}
                          checked={isChecked} 
                              onChange={(e) => handleShowOnFrontendChange(e, drupal_uid)}
                          /><label>Show on frontend</label><br/>
                          <input
                          type="checkbox"
                          name="field_represented_by_directors"
                          key={formData.field_represented_by_directors}
                          // checked={formData.field_represented_by_directors === 1}
                          checked={isRepresentedChecked} 
                          onChange={(e) => handleRepresentedByChange(e, drupal_uid)}
                          style={{marginTop: "10px"}}
                          /><label>Represented by Directors</label><br/><br/>
                          </div>
                        }
                       
                      </>
                    }

                     {publicurl && 
                        <>Public profile page URL: <a href={publicurl}>{publicurl}</a><br/><br/></>
                        }
                      <div className="view-athlete-head"
                     // className={`view-athlete-head ${hasChanges ? "container-changed" : ""}`}
                      >
                        
                        <div>
                            <b>Athlete Info</b>
                            {((showRedButton && showMyAthlete) || (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) &&
                            <img src="/basic/web/images/editaddress.gif" className="edit-model-btn" onClick={handleEditModalOpen}/>
                            }
                        </div>
           
                        
                            <div className="view-athlete-content" style={{"padding":"20px"}}>
                              <>
                                 <div className="view-athlete-imgwrapper">
                                   
                                    <img 
                                    // src={(typeof formData.picture === "string" && formData.picture) ? formData.picture 
                                    //   : (typeof athletedetails.picture_url=== "string" && athletedetails.picture_url) ? athletedetails.picture_url
                                    //   : "/basic/web/images/new_blogo.png"
                                    //  }
                                    src={currentImage}
                                    alt="profile"
                                    style={{ height: "100px", width: "100px" }}
                                    />         
                                    </div>
                                    {hasCustomImage && (
                                    <div>                                    
                                     
                                     <a href="#" onClick={(e) => { e.preventDefault(); handlePictureDelete(drupal_uid); }} >
                                      Delete photo
                                      <img
                                        style={{ width: "14px", verticalAlign: "text-bottom" }}
                                        src="/basic/web/images/delete_icon_round.png"
                                        alt="delete"
                                      />
                                    </a>
                                    </div>
                                    )}
                                    </>
                                   <div className="" style={{marginTop: "40px"}}>
                                        <div><b>ADDRESS INFORMATION</b></div>
                                        <div className=""><b>{athletedetails.address}</b>
                                        </div>
                                        <div className=""><b>{athletedetails.location}</b>
                                        </div>
                                    </div>
                                   <div className="" style={{marginTop: "40px"}}>
                                        <div><b>CONTACT INFORMATION</b></div>
                                        <table>
                                          <colgroup>
                                          <col style={{width: "30%"}}></col>
                                          <col style={{width: "70%"}}></col>
                                          </colgroup>
                                            <tr className="">
                                                <td><b>Email: </b></td><td>{athletedetails.email && athletedetails.email}</td>
                                            </tr>     
                                              <tr className="">
                                                <td><b>Phone: </b></td><td>{athletedetails.primary_phone && athletedetails.primary_phone}</td>
                                              </tr>    
                                              <tr className="">
                                                <td><b>Secondary Phone: </b></td><td>{athletedetails.field_secondary_phone && athletedetails.field_secondary_phone}</td>
                                              </tr>    
                                              <tr className="">
                                                <td><b>Night Phone: </b></td><td>{athletedetails.field_night_phone && athletedetails.field_night_phone}</td>
                                              </tr>    
                                              <tr className="">
                                                <td><b>LinkedIn URL: </b></td><td>{athletedetails.field_linkedin_url && athletedetails.field_linkedin_url}</td>
                                              </tr>    
                                              <tr className="">
                                                <td><b>Fax: </b></td><td>{athletedetails.field_fax && athletedetails.field_fax}</td>
                                              </tr>    
                                              <tr className="">
                                                <td><b>Pager: </b></td><td>{athletedetails.field_pager && athletedetails.field_pager}</td>
                                              </tr>     
                                        </table>                                                    
                                    </div>
                                  <div className="" style={{marginTop: "20px"}}>
                                        <div><b>Agent Info</b></div>
                                        <div className="">
                                            <table>
                                                <tr>
                                                    <td style={{padding: "5px"}}>
                                                        <b>Signing Agent: </b>{athletedetails.field_signing_agent_name && athletedetails.field_signing_agent_name}
                                                    </td>
                                                    <td style={{padding: "5px"}}>
                                                        <b>On: </b>{athletedetails.field_date_of_signing && athletedetails.field_date_of_signing}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{padding: "5px"}}>
                                                        <b>Current Agent: </b>{athletedetails.field_current_agent_name && athletedetails.field_current_agent_name} 
                                                    </td>
                                                    <td style={{padding: "5px"}}>
                                                        <b>On: </b>{athletedetails.field_date_of_assignment && athletedetails.field_date_of_assignment} 
                                                    </td>
                                                </tr>
                                                </table>
                                            </div>
                                     </div>
                         {/* <div className="" style={{marginTop: "5px"}}>
                        <div><b>Associated Sports</b></div>
                        <div className="" style={{textAlign: "center"}}><b>No Sports Associated</b></div>
                       </div>  */}
          <div style={{ marginTop: "5px" }}>
  <div><b>Associated Sports</b></div>

  {sportsDetails.length > 0 ? (
    <table>
      <tbody>
        {sportsDetails.map((item, index) => (
          <tr key={index} valign="top">
            <td>&nbsp;{item.sportName}</td>
            <td>&nbsp;{item.positionName}</td>
            <td align="center">
                             
                    <img src="/basic/web/images/editphonenumber.gif" alt="Edit Sport" title="Edit Sport" border="0" style={{cursor:"pointer"}} onClick={() => handleSportEditModalOpen(item)}/>&nbsp;
                                       
                    <img src="/basic/web/images/delete2.gif" alt="Remove Sport" title="Remove Sport" border="0"  style={{ cursor: "pointer" }}
  onClick={() => handleSportDelete(item)}/>
                          </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div style={{ textAlign: "center" }}><b>No Sports Associated</b></div>
  )}
</div>

                                  <div className="" style={{marginTop: "20px"}}>
                                        <div><b>Athlete Type: </b>{athleteType[athletedetails.field_athlete_type] || ""}</div>
                                  </div>

                   <div style={{ marginTop: "20px" }}>
  <div><b>Represented By</b></div>

  <div>
    {agentDetails.length > 0 ? (
      agentDetails.map((agent) => (
        <p key={agent.id}>{agent.name}&nbsp;
        {agents_represent
          .map(String)
          .includes(String(agent.id)) ? (
          <img
            style={{ width: "14px", verticalAlign: "text-bottom", cursor: "pointer" }}
            src="/basic/web/images/delete_icon_round.png"
            alt="delete"
            onClick={() => handleTableAgentDelete(agent.id)}
          />
        ) : (
          <span>*</span>
        )}
        </p>
      ))
    ) : (
      <p><i>No Agent Assigned</i></p>
    )}
  </div>
</div>

                    <div className="" style={{marginTop: "20px"}}>
                        <div><b>Athlete PDF Bio</b></div>
                        <div className="">
                            <table className="athlete-pdf-bio-table">
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Date of Birth: </b>{athletedetails.dob && athletedetails.dob}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Nationality: </b>{athletedetails.field_nationality && athletedetails.field_nationality}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Height: </b>{athletedetails.height && athletedetails.height}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Weight: </b>{athletedetails.weight && athletedetails.weight}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>Most recent College/ Club: </b>{athletedetails.field_most_recent_college && athletedetails.field_most_recent_college}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>Video Highlights: </b>{athletedetails.field_video_highlights && <div dangerouslySetInnerHTML={{ __html: athletedetails.field_video_highlights}} />}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>Most recent Season's Stats: </b>{athletedetails.field_most_recent_seasons_stats && <div dangerouslySetInnerHTML={{ __html: athletedetails.field_most_recent_seasons_stats}} />}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>Career Highlights: </b>{athletedetails.field_career_information && <div dangerouslySetInnerHTML={{ __html: athletedetails.field_career_information}} />}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>Client Social Media</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Instagram URL: </b>{athletedetails.field_instagram_url && athletedetails.field_instagram_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Instagram Handle: </b>{athletedetails.field_instagram_handle && athletedetails.field_instagram_handle}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Instagram Followers: </b>{athletedetails.field_instagram_followers && athletedetails.field_instagram_followers}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Facebook URL: </b>{athletedetails.field_facebook_url && athletedetails.field_facebook_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Facebook Handle: </b>{athletedetails.field_facebook_handle && athletedetails.field_facebook_handle}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Facebook Followers: </b>{athletedetails.field_facebook_followers && athletedetails.field_facebook_followers}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Twitter URL: </b>{athletedetails.field_twitter_url && athletedetails.field_twitter_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Twitter Followers: </b>{athletedetails.field_twitter_followers && athletedetails.field_twitter_followers}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Youtube URL: </b>{athletedetails.field_user_youtube_url && athletedetails.field_user_youtube_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Youtube Subscribers: </b>{athletedetails.field_youtube_subscribers && athletedetails.field_youtube_subscribers}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>LinkedIn URL: </b>{athletedetails.field_linkedin_url && athletedetails.field_linkedin_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>LinkedIn Handle: </b>{athletedetails.field_linkedin_handle && athletedetails.field_linkedin_handle}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>LinkedIn Followers: </b>{athletedetails.field_linkedin_followers && athletedetails.field_linkedin_followers}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{padding: "5px"}}>
                                        <b>Tiktok URL: </b>{athletedetails.field_tiktok_url && athletedetails.field_tiktok_url}
                                    </td>
                                    <td style={{padding: "5px"}}>
                                        <b>Tiktok Followers: </b>{athletedetails.field_tiktok_followers && athletedetails.field_tiktok_followers}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{padding: "5px"}}>
                                        <b>How to Contact Client: </b>{athletedetails.field_how_to_contact_client && <div dangerouslySetInnerHTML={{ __html: athletedetails.field_how_to_contact_client}} />}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                            </div>
                        </div>  
                         <div className="view-athlete-head" style={{marginTop: "20px"}}>
                        <div><b>Athlete Bio</b></div>
                        <div className="view-athlete-content">
                            {athletedetails.field_biography && <div dangerouslySetInnerHTML={{ __html: athletedetails.field_biography}} />}
                        </div>
                    </div> <br/>
                      <table id="event_logs_js" className="EventLog white"  border="0" cellpadding="2"  cellspacing="0">
        <tbody>
            <tr valign="top" >
                <td height="17" colspan="5" valign="top" align="left" class="infobar" style={{color:'white'}}><span>&nbsp;<b>Event Log</b> 20 Most Recent</span>&nbsp;&nbsp;<a href={"/eventlog/more/"+drupal_uid} target="_blank" style={{'color':'#2C99D2'}}>More</a></td>
                
            </tr>
           
               <tr style={{'background-color':'#CCCCCC' }} valign="top">
                <td>&nbsp;</td><td><b>Date</b></td><td><b>Who</b></td><td><b>Subject</b></td><td><b>Details</b></td>
            </tr>
               
             {eventlist.length > 0 ? (
            <>
            {eventlist.map((item, index) => {
                return <>
               <tr valign="top">
                <td><img src="/basic/web/images/viewlog.gif" style={{'cursor':'pointer'}} onClick={() => handleViewModalOpen('view_event_log',item['event_id'])}/></td><td>{item['date']}</td><td>{item['who']}</td><td>{item['subject']}</td><td>{item['details']}</td>
            </tr>
                </>
                    
            })}  
            </>
            ) : (
                <><tr id="no_events"><td colspan="5"><b>There are no events associated to this record</b></td></tr></>
            )}
            
        </tbody>
        </table><br/>

        {showEventViewModal && (           
<div id="myModal" className="modal view-event-modal">

 
  <div className="modal-content">
    <div className="modal-header">
      
      <h2>View Event Log</h2>
      <span className="close" onClick={() => handleModalClose('view_event_log')}>&times;</span>
    </div>
    <div class="modal-body">
        <table id="view-evenglog">
        <tbody>
        <tr>
            
            <td>EventID: <strong>{eventdetailedview.EventID}</strong></td>
            <td>Entered By: <strong>{eventdetailedview.EnteredBy}</strong>
            
            </td>
        </tr>
  
        <tr>
            <td>Event Date: <strong>{eventdetailedview.EventDate}</strong></td>
        </tr>
        <tr>
            <td>Bound To: <strong>{eventdetailedview.drupal_uid}</strong></td>
        </tr>
        <tr>
            <td>Subject: <strong>{eventdetailedview.Subject}</strong></td>
        </tr>
        <tr>
            <td>Details: <strong>{eventdetailedview.Details}</strong></td>
        </tr>
        </tbody>
        </table>
    </div>
   
  </div>

</div>
  )}   
       {showSportEditModal && (
  <div id="editModal" className="modal view-event-modal edit-modal-all">
    <div className="modal-content">
      <div className="modal-header">
        <h2>Edit Sport</h2>
        <span className="close" onClick={handleSportEditModalClose}>&times;</span>
      </div>
      <div className="modal-body edit-model">
        
        <form onSubmit={handleSportEditSubmit}>
            <div className="form-group">
            <label htmlFor="sportsID">Sports:</label>
            <select
              name="sportsId"
              id="sportsID"
              className="form-select"
              value={sportformData.sportsId}
              onChange={handleSportEditInputChange}
            >
              {sportList.map((sport) => (
                <option key={sport.key} value={sport.key}>
                  {sport.value}
                </option>
              ))}
            </select>
          </div>
          <p>
            If you don't see the position below, please contact{' '}
            <a href="mailto:info@smwwagency.com">info@SMWWAgency.com</a>
          </p>
      <div className="form-group">
        <label htmlFor="positions">Positions:</label>
        <select
          name="positions"
          id="positions"
          className="form-select"
          value={sportformData.positions}
          onChange={handleSportEditInputChange}
        >
          {sportpositionsList.map((position) => (
            <option key={position.id} value={position.id}>
              {position.name}
            </option>
          ))}
        </select>
      </div>
	     <div className="btn-actions form-item">
            {/* <input type="submit" id="edit-submit" style={{cursor:"pointer"}} value="Save Sport and Position" className="" onClick={handleEditInputChange} />&nbsp; */}
            <button type="submit">
    Save Sport and Position
</button></div>
</form>
</div>
</div>
</div>
)}                     
      {showEditModal && (
  <div id="editModal" className="modal view-event-modal edit-modal-all" ref={modalContentRef}>
    <div className="modal-content">
      <div className="modal-header">
        <h2>Edit Athlete Details</h2>
        <span className="close" onClick={handleEditModalClose}>&times;</span>
      </div>
      <div className="modal-body edit-model">
        {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
        <form onSubmit={handleEditSubmit}>
          <div className={getFieldClass("picture")}>
            <label>Add/Edit Photo:</label>
            {currentPreviewImage && (
                <div className="view-athlete-imgwrapper">
                    <img
                        src={currentPreviewImage}
                        alt="profile"
                        style={{ height: "100px", width: "100px" }}
                    />
                </div>
            )}
            <PhotoEditor 
                 onPhotoSelect={(file) =>
                setFormData((prev) => ({ ...prev, picture: file }))
                 }
              
            />
          </div>
            <div className="form-group">
                <label htmlFor="edit-field-firstname">First Name</label>
                <input 
                    className={`form-text view-athlete-text-field ${getFieldClass("first_name")}`}
                    type="text" 
                    id="edit-field-firstname" 
                    name="first_name" 
                    value={formData.first_name} 
                    onChange={handleEditInputChange}
                    maxLength="50"
                />
            </div>
             <div className="form-group">
                <label htmlFor="edit-field-lastname">Last Name</label>
                <input 
                    className={`form-text view-athlete-text-field ${getFieldClass("last_name")}`}
                    type="text" 
                    id="edit-field-lastname" 
                    name="last_name" 
                    value={formData.last_name} 
                    onChange={handleEditInputChange}
                    maxLength="50"
                />
            </div> 
            <div className="form-group">
                <label htmlFor="edit-field-street">Street</label>
                <input 
                    className={`form-text view-athlete-text-field ${getFieldClass("street_address")}`} 
                    type="text" 
                    id="edit-field-street" 
                    name="street_address" 
                    value={formData.street_address} 
                    onChange={handleEditInputChange}
                    maxLength="255"
                />
            </div>
            <div className="form-group">
             <label htmlFor="edit-field-street-2">Street 2</label>
		     <input 
                className={`form-text view-athlete-text-field ${getFieldClass("field_street_2")}`} 
                type="text" 
                id="edit-field-street-2" 
                name="field_street_2" 
                value={formData.field_street_2} 
                onChange={handleEditInputChange}
                maxLength="255"
              />
          </div>
          <div className="form-group">
           <label htmlFor="edit-field-city">City </label>
	      <input 
            className={`form-text view-athlete-text-field ${getFieldClass("city")}`}
            type="text" 
            id="edit-field-city" 
            name="city" 
            maxLength="255"  
            value={formData.city}
            onChange={handleEditInputChange} 
          />
          </div>
          <div className="form-group">                                
            <label htmlFor="edit-field-state">State</label>
            <select className={`${getFieldClass("state")}`} id="edit-field-state" name="state" value={formData.state}  onChange={handleEditInputChange} >
            <option value=""></option>
            {Object.keys(statelist).map(state => {
              return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
            })}
            </select>                     
         </div>
          <div className="form-group">
            
            <label htmlFor="edit-field-country">Country</label>
            <div style={{display:"inline-block", marginTop:"5px", marginBottom:"5px"}}>
                <Select 
                    className={`${getFieldClass("country")}`}
                    id="edit-field-country" name="country"
                    searchable={true}                
                    clearable={true} 
                    clearOnBlur={true} 
                    clearOnSelect={true}
                    backspaceDelete={true}                
                    style={{backgroundColor:'#ffffff', width:'300px', borderRadius: 5}}                                
                    options={countriesList}                 
                    onChange={(val) => {
                    if(val.length == 0) {
                        console.log(val);
                    }
                    else{
                        setSelectedCountry(val);
                    handleEditInputChange(
                        { target: { value: val[0]['value'], name: 'country' } }
                    )
                    
                    }}
                    }
                    onDropdownOpen={handleOpen}
                    values={selectedcountry} 
                    
                    />     
                </div>   
          </div>
          <div className="form-group">
             <label for="edit-field-postal">Postal Code </label>
		     <input 
                className={`form-text view-athlete-text-field ${getFieldClass("postal_code")}`} 
                type="text" 
                id="edit-field-postal" 
                name="postal_code" 
                value={formData.postal_code} 
                onChange={handleEditInputChange} 
                maxLength="20"
             />
          </div>
          <div className="form-group">
           <label htmlFor="edit-mail">E-mail address <span className="form-required" title="This field is required.">*</span></label>
	         <input 
            type="text" 
            id="edit-mail" 
            name="email" 
            value={formData.email} 
            onChange={handleEditInputChange}
            maxLength="254" 
            className={`form-text view-athlete-text-field ${getFieldClass("email")}`}
           />
          </div>
          <div className="form-group">
            <label htmlFor="edit-field-phone">Phone </label>
		        <input 
              className={`form-text view-athlete-text-field ${getFieldClass("primary_phone")}`} 
              type="text" 
              id="edit-field-phone" 
              name="primary_phone" 
              value={formData.primary_phone} 
              onChange={handleEditInputChange} 
              maxLength="100"
            />
          </div>
          <div className="form-group">
            <label htmlFor="edit-field-secondary-phone">Secondary Phone </label>
		        <input 
              className={`form-text view-athlete-text-field ${getFieldClass("field_secondary_phone")}`}
              type="text" 
              id="edit-field-secondary-phone" 
              name="field_secondary_phone" 
              value={formData.field_secondary_phone} 
              onChange={handleEditInputChange} 
              maxLength="100"
            />
          </div>
          <div className="form-group">
            <label htmlFor="edit-field-night-phone">Night Phone </label>
		        <input 
              className={`form-text view-athlete-text-field ${getFieldClass("field_night_phone")}`}
              type="text" 
              id="edit-field-night-phone" 
              name="field_night_phone" 
              value={formData.field_night_phone} 
              onChange={handleEditInputChange} 
              maxLength="100"
            />
          </div>
          <div className="form-group">
              <label htmlFor="edit-field-linkedin-url">LinkedIn URL </label>
              <input 
                className={`form-text view-athlete-text-field ${getFieldClass("field_linkedin_url")}`} 
                type="text" 
                id="edit-field-linkedin-url" 
                name="field_linkedin_url" 
                value={formData.field_linkedin_url} 
                onChange={handleEditInputChange} 
                maxLength="100"
              />
          </div>
          <div className="form-group">
            <label htmlFor="edit-field-fax">Fax </label>
		        <input 
              className={`form-text view-athlete-text-field ${getFieldClass("field_fax")}`}
              type="text" 
              id="edit-field-fax" 
              name="field_fax" 
              value={formData.field_fax} 
              onChange={handleEditInputChange} 
              maxLength="30"/>
          </div>
          <div className="form-group">
              <label htmlFor="edit-field-pager">Pager </label>
              <input 
                className={`form-text view-athlete-text-field ${getFieldClass("field_pager")}`} 
                type="text" 
                id="edit-field-pager" 
                name="field_pager" 
                value={formData.field_pager} 
                onChange={handleEditInputChange} 
                maxLength="100"
              />
          </div>
          <div className="form-group">
            <label htmlFor="sportsID">Sports:</label>
            <select
              name="sportsId"
              id="sportsID"
              className={`form-select ${getFieldClass("sportsId")}`}
              value={formData.sportsId}
              onChange={handleEditInputChange}
            >
              {sportList.map((sport) => (
                <option key={sport.key} value={sport.key}>
                  {sport.value}
                </option>
              ))}
            </select>
          </div>
          <p>
            If you don't see the position below, please contact{' '}
            <a href="mailto:info@smwwagency.com">info@SMWWAgency.com</a>
          </p>
      <div className="form-group">
        <label htmlFor="positions">Positions:</label>
        <select
          name="positions"
          id="positions"
          multiple
          size="5"
          className={`form-select ${getFieldClass("positions")}`}
          value={formData.positions}
          onChange={handleEditInputChange}
        >
          {positionsList.map((position) => (
            <option key={position.id} value={position.id}>
              {position.name}
            </option>
          ))}
        </select>
      </div>
    <div className="form-group">
        <label htmlFor="atype">Athlete Type</label>    
        <select
          id="atype"
          name="field_athlete_type"
          value={formData.field_athlete_type}
          onChange={handleEditInputChange}
          className={`${getFieldClass("field_athlete_type")}`}
        >
          <option value="_none">- None -</option>
              {Object.entries(athleteType).map(([value, label]) => (
                <option key={value} value={value}>
                {label}
                </option>
              ))}
        </select>
    </div>
    <div className="form-group">
        <strong>Represented By</strong><br /><br />
        <div>
    {agentDetails.length > 0 ? (
      agentDetails.map((agent) => (
        <p key={agent.id}
        //  className={getAgentClass(agent.id)}
          className={getFieldClass(removedFields.includes("field_agents_represented_by") ? "field_agents_represented_by" : "")}
        >{agent.name}&nbsp;
        {agents_represent
          .map(String)
          .includes(String(agent.id)) ? (
          <img
            style={{ width: "14px", verticalAlign: "text-bottom", cursor: "pointer" }}
            src="/basic/web/images/delete_icon_round.png"
            alt="delete"
            onClick={() => handleAgentDelete(agent.id)}
          />
        ) : (
          <span>*</span>
        )}
        </p>
      ))
    ) : (
      <p><i>No Agent Assigned</i></p>
    )}
  </div>

        <ReactSelect
        isMulti
        options={agentOptionsFormatted}
        value={formData.field_agents_represented_by}
        onChange={(selectedOptions) => {
            setFormData(prev => ({
            ...prev,
            field_agents_represented_by: selectedOptions,
            }));
            setErrors(prev => ({ ...prev, field_agents_represented_by: '' }));
        }}
        className={getFieldClass(addedFields.includes("field_agents_represented_by") ? "field_agents_represented_by" : "")}
        />
    </div>
     <div className="">
        <table className="edit-athlete-bio-table">
          <tbody>
            <tr>
              <td className="pdf-bio-left">
                <strong>Date of Birth:<span className="form-required">*</span></strong>
                 <select
          name="birth_month"
          value={formData.birth_month}
          onChange={handleEditInputChange}
          className={getFieldClass("birth_month")}
        >
          <option value="">Month</option>
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
          &nbsp;
        <select
          name="birth_date"
          value={formData.birth_date}
          onChange={handleEditInputChange}
          className={getFieldClass("birth_date")}
        >
          <option value="">Day</option>
          {days.map((d) => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
          &nbsp;
        <select
          name="birth_year"
          value={formData.birth_year}
          onChange={handleEditInputChange}
          className={getFieldClass("birth_year")}
        >
          <option value="">Year</option>
          {years.map((y) => (
            <option key={y.value} value={y.value}>
              {y.label}
            </option>
          ))}
        </select>
              </td>
              </tr>
              <tr>
              <td className="pdf-bio-right">
            <strong>Nationality:<span class="form-required">*</span></strong> 

            <input type="text" name="field_nationality" id="nationality" className={`form-group ${getFieldClass("field_nationality")}`}  value={formData.field_nationality}
                      onChange={handleEditInputChange}/>
            </td>
            </tr>
            <tr>
  {/* HEIGHT */}
  <td className="pdf-bio-left">
    <strong>Height:<span className="form-required">*</span></strong>

    {formData.field_height_unit === 'Imperial' ? (
      <>
        <input
          type="number"
          name="height_ft"
          value={formData.height_ft || ''}
          onChange={handleEditInputChange}
          placeholder="Ft"
          className={getFieldClass("field_height_unit")}
        /> Ft
        <input
          type="number"
          name="height_in"
          value={formData.height_in || ''}
          onChange={handleEditInputChange}
          placeholder="In"
           className={getFieldClass("field_height_unit")}
        /> In
      </>
    ) : (
      <input
        type="number"
        name="height_cm"
        value={formData.height_cm || ''}
        onChange={handleEditInputChange}
        placeholder="cm"
         className={getFieldClass("field_height_unit")}
      />
    )}

    {/* Height unit toggle */}
    <span id="height_radio_unit">
      <label>
        <input
          type="radio"
          name="field_height_unit"
          value="Imperial"
          checked={formData.field_height_unit === 'Imperial'}
          onChange={handleEditInputChange}
          style={{verticalAlign:"bottom"}}
        /> Imperial
      </label>
      <label>
        <input
          type="radio"
          name="field_height_unit"
          value="Metric"
          checked={formData.field_height_unit === 'Metric'}
          onChange={handleEditInputChange}
          style={{verticalAlign:"bottom"}}
        /> Metric
      </label>
    </span>    
  </td>
  </tr>
  <tr>
  {/* WEIGHT */}
  <td className="pdf-bio-right">
    <strong>Weight:<span className="form-required">*</span></strong>
    <input
      type="number"
      name="field_athlete_weight"
      value={formData.field_athlete_weight || ''}
      onChange={handleEditInputChange}
      placeholder={formData.field_weight_unit === 'lb' ? 'lb' : 'kg'}
      className={getFieldClass("field_athlete_weight")}
    />

    {/* Weight unit toggle */}
    <span id="weight_radio_unit">
      <label>
        <input
          type="radio"
          name="field_weight_unit"
          value="lb"
          checked={formData.field_weight_unit === 'lb'}
          onChange={handleEditInputChange}
          style={{verticalAlign:"bottom"}}
        /> lb
      </label>
      <label>
        <input
          type="radio"
          name="field_weight_unit"
          value="kg"
          checked={formData.field_weight_unit === 'kg'}
          onChange={handleEditInputChange}
          style={{verticalAlign:"bottom"}}
        /> kg
      </label>
    </span>
  </td>
</tr>
<tr></tr>
<tr><td colspan="2">
<strong>Most Recent College/Club:<span class="form-required">*</span></strong>
<input type="text" name="field_most_recent_college" id="most_recnt_college" value={formData.field_most_recent_college}
          onChange={handleEditInputChange}
          className={getFieldClass("field_most_recent_college")}/>
</td>
</tr>
<tr>
  <td colSpan={3}>
     <label>Video Highlights</label>
      <Editor value={formData.field_video_highlights} 
      onChange={e => onEditorChange("field_video_highlights", e)}
      className={getFieldClass("field_video_highlights")}
      />   
  </td>
</tr>
<tr>
  <td colSpan={3}>
     <label>Most Recent Season's Stats:<span className="form-required">*</span></label>
      <Editor value={formData.field_most_recent_seasons_stats}
       onChange={e => onEditorChange("field_most_recent_seasons_stats", e)}
       className={getFieldClass("field_most_recent_seasons_stats")}
        />   
  </td>
</tr>
<tr>
  <td colSpan={3}>
     <label>Career Highlights:<span className="form-required">*</span></label>
      <Editor value={formData.field_career_information} onChange={e => onEditorChange("field_career_information", e)} 
        className={getFieldClass("field_career_information")}/>   
  </td>
</tr>
{/* Client Social Media Section */}

<tr>
  <td colspan={3}>
    <strong>Client Social Media (Optional):</strong>
  </td>
</tr>

{/* Instagram */}
<tr>
  <td className="pdf-bio-left-social">
    <strong>Instagram URL:</strong>
    <input
      type="text"
      name="field_instagram_url"
      value={formData.field_instagram_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_instagram_url")}`}
    />
  </td>
  <td className="pdf-bio-center-social">
    <strong>Instagram Handle:</strong>
    <input
      type="text"
      name="field_instagram_handle"
      value={formData.field_instagram_handle}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_instagram_handle")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of Instagram Followers</strong>
    <input
      type="text"
      name="field_instagram_followers"
      value={formData.field_instagram_followers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_instagram_followers")}`}
    />
  </td>
</tr>

{/* Facebook */}
<tr>
  <td className="pdf-bio-left-social">
    <strong>Facebook URL:</strong>
    <input
      type="text"
      name="field_facebook_url"
      value={formData.field_facebook_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_facebook_url")}`}
    />
  </td>
  <td className="pdf-bio-center-social">
    <strong>Facebook Handle:</strong>
    <input
      type="text"
      name="field_facebook_handle"
      value={formData.field_facebook_handle}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_facebook_handle")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of Facebook Followers</strong>
    <input
      type="text"
      name="field_facebook_followers"
      value={formData.field_facebook_followers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_facebook_followers")}`}
    />
  </td>
</tr>

{/* Twitter */}
<tr>
  <td colSpan="2" className="pdf-bio-left-social">
    <strong>Twitter URL:</strong>
    <input
      type="text"
      name="field_twitter_url"
      value={formData.field_twitter_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_twitter_url")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of Twitter Followers</strong>
    <input
      type="text"
      name="field_twitter_followers"
      value={formData.field_twitter_followers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_twitter_followers")}`}
    />
  </td>
</tr>

{/* YouTube */}
<tr>
  <td colSpan="2" className="pdf-bio-left-social">
    <strong>YouTube URL:</strong>
    <input
      type="text"
      name="field_user_youtube_url"
      value={formData.field_user_youtube_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_user_youtube_url")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of YouTube Subscribers</strong>
    <input
      type="text"
      name="field_youtube_subscribers"
      value={formData.field_youtube_subscribers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_youtube_subscribers")}`}
    />
  </td>
</tr>

{/* LinkedIn */}
<tr>
  <td className="pdf-bio-left-social">
    <strong>LinkedIn URL:</strong>
    <input
      type="text"
      id="edit-field-linkedin-url"
      name="field_linkedin_url"
      value={formData.field_linkedin_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_linkedin_url")}`}
      maxLength="100"
    />
  </td>
  <td className="pdf-bio-center-social">
    <strong>LinkedIn Handle:</strong>
    <input
      type="text"
      name="field_linkedin_handle"
      value={formData.field_linkedin_handle}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_linkedin_handle")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of LinkedIn Followers</strong>
    <input
      type="text"
      name="field_linkedin_followers"
      value={formData.field_linkedin_followers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_linkedin_followers")}`}
    />
  </td>
</tr>

{/* TikTok */}
<tr>
  <td className="pdf-bio-left-social">
    <strong>TikTok URL:</strong>
    <input
      type="text"
      name="field_tiktok_url"
      value={formData.field_tiktok_url}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_tiktok_url")}`}
    />
  </td>
  <td className="pdf-bio-right-social">
    <strong># of TikTok Followers</strong>
    <input
      type="text"
      name="field_tiktok_followers"
      value={formData.field_tiktok_followers}
      onChange={handleEditInputChange}
      className={`form-group ${getFieldClass("field_tiktok_followers")}`}
    />
  </td>
</tr>

<tr>
  <td colSpan={3}>
     <label>How to Contact Client (Optional):</label>
      <Editor value={formData.field_how_to_contact_client} 
      onChange={e => onEditorChange("field_how_to_contact_client", e)}
      className={getFieldClass("field_how_to_contact_client")}
       />   
  </td>
</tr>
<tr>
  <td colSpan={3}>
     <label>Athlete Bio:</label>
      <Editor value={formData.field_biography} 
      onChange={e => onEditorChange("field_biography", e)}
      className={getFieldClass("field_biography")}
       />   
  </td>
</tr>

          </tbody>
        </table>
     </div>   
          <div className="btn-actions form-item">
            {/* <input type="submit" id="edit-submit" style={{cursor:"pointer"}} value="Save" className="" onClick={handleEditInputChange} />&nbsp; */}
            <button type="submit">
    Save
</button>&nbsp;
            <input type="button" id="edit-submit"  style={{cursor:"pointer",height:"22px"}} value="Cancel" className=""  onClick={handleEditCancel}/>
          </div>
          </form>
      </div>
    </div>
  </div>
)}   
   
                
            </div>
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        
        </div>
        )}
    </>
    );
};
export default Viewathlete;